// Found on stackoverflow, it is a type that "replicates" an "any Class"
// (I mean, any type of Class that is not instanciated yet)
// https://stackoverflow.com/questions/39392853/is-there-a-type-for-class-in-typescript-and-does-any-include-it
type Constructor<T = any> = new (...args: any[]) => T;

type ClassInstanceType = ThisType<any>;
type ClassType = InstanceType<Constructor<any>>;

// TODO: Don't forget to remove this when Alpine have implemented a fix for this.
// Discussion about the issue: https://github.com/alpinejs/alpine/discussions/4622
// Ticket to apply this for all Alpine.store: https://tubeengine.atlassian.net/browse/SB-4713
export const attachInitToStoreInstance = (storeInstance: ClassInstanceType, storeClass: ClassType) => {
    // We are only attaching "init" method to the class if it is declared inside
    if (typeof storeClass.prototype.init !== 'function') {
        return;
    }

    Object.defineProperty(storeInstance, 'init', {
        value: storeClass.prototype.init,
        enumerable: true,
        configurable: true,
    });
};
